import { render, staticRenderFns } from "./ChatQuickForm.vue?vue&type=template&id=79ba3220&"
import script from "./ChatQuickForm.vue?vue&type=script&lang=js&"
export * from "./ChatQuickForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatQuickForm.vue?vue&type=style&index=0&id=79ba3220&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports